import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import SystemNotificationsAdminList from './components/SystemNotificationsAdminList';
import SystemNotificationsAdminAddSystemNotificationPage from './components/SystemNotificationsAdminAddSystemNotificationPage';
import SystemNotificationsAdminGetSystemNotificationData from './components/SystemNotificationsAdminGetSystemNotificationData';

const SystemNotificationsAdminPage: React.FC = () => {
  const [tab, setTab] = useState(0);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs value={tab} onChange={handleTabChange} aria-label="User admin tabs">
        <Tab label="List Notifications" />
        <Tab label="Add Notification" />
        <Tab label="Notification Data" />
      </Tabs>
      <Box sx={{ mt: 2 }}>
        {tab === 0 && <SystemNotificationsAdminList />}
        {tab === 1 && <SystemNotificationsAdminAddSystemNotificationPage />}
        {tab === 2 && <SystemNotificationsAdminGetSystemNotificationData />}
      </Box>
    </Box>
  );
};

export default SystemNotificationsAdminPage;